module.exports = __webpack_public_path__ + "img/tela-artmed360.207f87fd.png";